import { FC } from 'react';
import { PageTitle } from '../../../../../_metronic/layout/core';
import { View } from './components/View';
import { useParams } from 'react-router-dom';
import { decryptId } from '../../../../../_metronic/helpers';

const PreviewPdf: FC = () => {
  const { id } = useParams<{ id: string }>();
  const orden_cobro_id = decryptId(id);

  return (
    <>
      <PageTitle breadcrumbs={[]}>Generar PDF</PageTitle>
      <View id={orden_cobro_id ? Number(orden_cobro_id) : 0} />
    </>
  );
};

export { PreviewPdf };
